import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';

import { View, Text } from '../../../Base';
import { LocationIcon, ParcelIcon, RoadIcon } from '../../../icons';
import OpportunityTime from './OpportunityTime';
import palette from '../../../styles/palette';

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '0.313rem',
    justifyContent: 'space-between',
  },
  text: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: 'white',
    flexDirection: 'row',
    display: 'flex',
    letterSpacing: '-0.02rem',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    width: '0.75rem',
    height: '0.75rem',
    marginLeft: '0.125rem',
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      width: '0.75rem',
      height: '0.75rem',
      fill: palette.typography.white.medium,
    },
  },
}));

const totalColumns = [
  {
    value: 'totalStops',
    icon: <LocationIcon />,
    testId: 'total-stops',
  },
  {
    value: 'totalParcels',
    icon: <ParcelIcon />,
    testId: 'total-parcels',
  },
  {
    value: 'totalMiles',
    icon: <RoadIcon />,
    testId: 'total-miles',
  },
];

const TotalDataRow = ({ route }) => {
  const styles = useStyles();

  return (
    <View className={styles.row}>
      {totalColumns.map(({ value, icon, testId }) => (
        <View key={value} className={styles.textContainer}>
          <Text className={styles.text} data-testid={testId}>
            {`${route[value]}`.padStart(3, '0')}
          </Text>
          <View className={styles.icon}>{icon}</View>
        </View>
      ))}
      <OpportunityTime value={route.opportunityTime} />
    </View>
  );
};

export default memo(TotalDataRow);
